import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/previous.svg'
import _imports_1 from '../creators/assets/images/Mobile-Gaming.png'


const _withScopeId = n => (_pushScopeId("data-v-349e7c83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid p-col-12 p-lg-11 p-ml-lg-6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"max-height":"10px"}
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title p-col-12 p-mt-4" }, "Pay and Finish Campaign", -1))
const _hoisted_4 = { class: "p-d-flex p-ai-center p-justify-between header-title p-col-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-block p-col-2 p-lg-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "logo"
  })
], -1))
const _hoisted_6 = { class: "name p-col-7 p-lg-3" }
const _hoisted_7 = { class: "p-col-6 p-lg-1 p-mt-4 p-mt-lg-0" }
const _hoisted_8 = { class: "market p-col-6 p-lg-2 p-mt-4 p-mt-lg-0" }
const _hoisted_9 = { class: "time-left p-col-6 p-lg-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "budget p-col-6 p-lg-1" }, "300.00 USD", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details cursor p-col-12 p-lg-1" }, "View Details", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusChip = _resolveComponent("StatusChip")!
  const _component_PaymentMethods = _resolveComponent("PaymentMethods")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h6", {
      class: "cursor p-col-12",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, [
      _hoisted_2,
      _createTextVNode(" Back to Campaign")
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, _toDisplayString($setup.campaign?.name), 1),
      _createElementVNode("div", _hoisted_7, [
        ($setup.campaign)
          ? (_openBlock(), _createBlock(_component_StatusChip, {
              key: 0,
              status: $setup.campaign?.status
            }, null, 8, ["status"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString($setup.campaign?.targetMarket?.title), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString($setup.parseApplicationTimeLeft($setup.campaign?.period)) + " (TODO)", 1),
      _hoisted_10,
      _hoisted_11
    ]),
    _createVNode(_component_PaymentMethods)
  ]))
}